var $3719245abc082946$exports = {};
$3719245abc082946$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, " azalt");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, " artt\u0131r");
  },
  "numberField": "Say\u0131 alan\u0131"
};
export { $3719245abc082946$exports as default };